/**
* Ids.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* IDs.
*/
import { isValueAssigned } from "@microsoft/applicationinsights-core-js";
import { notImplementedWarn } from "./Utils";
var Ids = /** @class */ (function () {
    function Ids(sku) {
        this._sku = sku;
    }
    Ids.prototype.getVisitorId = function () {
        return this._sku.getPropertyManager().getPropertiesContext().user.localId;
    };
    Ids.prototype.getMuidUserId = function (allCookies) {
        var muid = this._sku.getPropertyManager().getPropertiesContext().user.localId;
        return isValueAssigned(muid) ? "t:" + muid : "";
    };
    Ids.prototype.setDeviceClass = function (deviceClass) {
        this._sku.getPropertyManager().getPropertiesContext().device.deviceClass = deviceClass;
    };
    Ids.prototype.getDeviceClass = function () {
        return this._sku.getPropertyManager().getPropertiesContext().device.deviceClass;
    };
    Ids.prototype.setAppUserId = function (userId) {
        // There is no User ID in CS4 App extensions
        // NO OP
        notImplementedWarn("setAppUserId");
    };
    Ids.prototype.getAppUserId = function () {
        // There is no User ID in CS4 App extensions
        // NO OP
        notImplementedWarn("getAppUserId");
        return "";
    };
    Ids.prototype.readExpIdFromCookie = function (allCookies) {
        // In 1DS these methods are internal to get exp ID
        // NO OP
        notImplementedWarn("readExpIdFromCookie");
        return "";
    };
    Ids.prototype.getImpressionGuid = function () {
        // There is no impression Guid
        // NO OP
        notImplementedWarn("getImpressionGuid");
        return "";
    };
    Ids.prototype.getGroups = function () {
        // In 1DS these methods are internal to get exp ID
        // NO OP
        notImplementedWarn("getGroups");
        return "";
    };
    Ids.prototype.setExpIdCookieName = function (name) {
        // In 1DS these methods are internal to get exp ID
        // NO OP
        notImplementedWarn("setExpIdCookieName");
        return "";
    };
    Ids.prototype.readExpIdFromCoreData = function (expId) {
        // In 1DS these methods are internal to get exp ID
        // NO OP
        notImplementedWarn("readExpIdFromCoreData");
        return "";
    };
    Ids.prototype.getPageViewImpressionGuid = function () {
        // NO OP
        notImplementedWarn("getPageViewImpressionGuid");
        return "";
    };
    return Ids;
}());
export { Ids };
//# sourceMappingURL=Ids.js.map